import React, { useEffect, useState } from "react"

/**
 * @param tabs - tabs content
 * @param active - active tab
 * @param handleActive - handle the active tab
 * @param multipleProducts - the tabs for different products
 * */
const Tabs = ({ tabs, active, handleActive }) => {
  /*==========================
  Format the product name
  =========================*/
  const [tabsText, setTabsText] = useState([])
  useEffect(() => {
    if (!tabs || !tabs.length) return

    let formattedNames = []
    tabs.forEach(product => {
      let name = product.replaceAll("-", " ")

      if (name === "vanilla protein") {
        name = 'I <i class="fa fa-heart txt--pink"></i> Vanilla Protein'
      }

      if (name === "chocolate protein") {
        name = `I <i class="fa fa-heart txt--pink"></i> Chocolate Protein`
      }
      formattedNames = [...formattedNames, name]
    })

    setTabsText(formattedNames)
  }, [tabs])

  /*==========================
  ACTIVE EVENT
  =========================*/
  const changeActive = e => {
    handleActive(e.target.getAttribute("id"))
  }

  return (
    <>
      {tabs && tabs.length > 0 && (
        <div className="container">
          <div className={`tabs tabs-supplements tabs--${tabs.length}`}>
            {tabs.map((tab, index) => (
              <button
                key={`tabs-${tab}`}
                aria-label="Open tab."
                id={tab}
                onClick={changeActive}
                className={`tab ${active === tab ? "active" : ""}`}
                dangerouslySetInnerHTML={{
                  __html: tabsText[index],
                }}
              />
            ))}
          </div>
        </div>
      )}
    </>
  )
}
export default Tabs
